import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Menu } from './MenuData'
import { Link } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import { useDispatch, useSelector } from 'react-redux';
import { logOut } from '../../redux/userRedux';
import './NavBar.css'


const NavBar = () => {
   const [stickyClass, setStickyClass] = useState('relative');
   const [menuOpen,setMenuOpen] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const userMenuRef = useRef<HTMLDivElement | null>(null);
  const dispatch = useDispatch();
  const currentUser = useSelector((state: any) => state?.user?.currentUser);
  const isLoggedIn = Boolean(currentUser);

  const userDisplayName = useMemo(() => {
   return currentUser?.fullName || currentUser?.username || currentUser?.name || 'Mi Cuenta';
  }, [currentUser]);

  const userInitials = useMemo(() => {
   const safeName = String(userDisplayName || '').trim();
   if (!safeName) return 'MS';

   const parts = safeName.split(' ').filter(Boolean);
   if (parts.length > 1) {
    return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
   }

   return parts[0].slice(0, 2).toUpperCase();
  }, [userDisplayName]);

  useEffect(() => {
    window.addEventListener('scroll', stickNavbar);

    return () => {
      window.removeEventListener('scroll', stickNavbar);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (!userMenuRef.current) return;
      if (!userMenuRef.current.contains(event.target as Node)) {
        setShowUserMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const stickNavbar = () => {
    if (window !== undefined) {
      let windowHeight = window.scrollY;
      windowHeight > 500 ? setStickyClass('fixed top-0 left-0 z-50 navbar-box') : setStickyClass('relative');
    }
  };

  const handleLogout = () => {
    dispatch(logOut());
    setShowUserMenu(false);
    setMenuOpen(false);
  };


  return (
    <nav className={`flex justify-between p-3 items-center w-full bg-white top-0 relative ${stickyClass}`}>
      {isLoggedIn ? (
        <Link to="/user" className="mobile-user-avatar sm:hidden" aria-label="Ir al dashboard">
          {userInitials}
        </Link>
      ) : (
        <span className="mobile-user-placeholder sm:hidden" aria-hidden="true" />
      )}

      <MenuIcon onClick={()=>setMenuOpen(true)} className={`z-20 burger-menu hidden mobile-menu-button`}/>
      <img src="../../assets/icons/Logo/Logo-sm.png" width={50} alt="Logo" className='hidden sm:block' />
      <ul className={`menu-items-box gap-5 flex-grow justify-center items-center pl-[5.5rem] ${menuOpen ? 'menu-active':''}`}>
        <CloseIcon className='close-icon absolute' onClick={()=>setMenuOpen(false)}/>
        {Menu.map((menuItem, index) => (
          <Link
            to={menuItem.name === 'Mi Espacio' && isLoggedIn ? '/index' : menuItem.path}
            key={menuItem.name || index}
            onClick={() => setMenuOpen(false)}
          >
                <li className='menu-item'>{menuItem.name}</li>
            </Link>
        ))}
    </ul>
      <ul id="social-icons">
        <a href="https://instagram.com/sar.asanas?igshid=MzRlODBiNWFlZA==" className='icon-img'><img src="../../assets/icons/Socials/instagram_icn.svg" alt="instagram-icon" /></a>
        <a href="https://www.facebook.com/profile.php?id=100038357469052&mibextid=LQQJ4d" className='icon-img'><img src="../../assets/icons/Socials/facebook_icn.svg" alt="facebook-icon" /></a>
        <a href="https://youtube.com/@sar.asanas3495?si=iLg2xdpmsI2XwglC" className='icon-img'><img src="../../assets/icons/Socials/play.png" alt="youtube-icon" className="youtube-social-icon" /></a>
        <a href="https://open.spotify.com/show/5ixh2ge9moyf2nfEw0EANH?si=83d3c37b6e904ac4" className='icon-img'><img src="../../assets/icons/Socials/Spotify.svg" alt="spotify-icon" /></a>
        {/*<AccountCircleIcon/>*/}
      </ul>
      {isLoggedIn && (
        <div className="auth-actions" ref={userMenuRef}>
          <button
            className="user-trigger"
            onClick={() => setShowUserMenu((prev) => !prev)}
            aria-label="Abrir menu de usuario"
          >
            <span className="user-avatar">{userInitials}</span>
            <span className="user-name hidden sm:inline">{userDisplayName}</span>
            <KeyboardArrowDownOutlinedIcon className={`chevron ${showUserMenu ? 'open' : ''}`} />
          </button>

          {showUserMenu && (
            <div className="user-dropdown">
              <Link to="/user" className="user-dropdown-item" onClick={() => setShowUserMenu(false)}>
                <DashboardOutlinedIcon fontSize="small" />
                Dashboard
              </Link>
              <button className="user-dropdown-item" onClick={handleLogout}>
                <LogoutOutlinedIcon fontSize="small" />
                Cerrar Sesión
              </button>
            </div>
          )}
        </div>
      )}
      <img src="../../assets/icons/Logo/Logo-sm.png" width={50} alt="Logo" className='block sm:hidden mobile-center-logo'/>
    </nav>
  )
}

export default NavBar